<div class="rut-validator-page">
  <main class="rut-validator-main">
    <div class="container">

      <div class="rut-validator-title">
        <h1>Validador de RUT</h1>
        <p>Ingresa el RUT del paciente para validar si es paciente de AlmaMedis.</p>
      </div>

      <div class="row justify-content-center">
        <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">

          <div class="rut-validator-card">
            <div class="rut-validator-card-header">
              <div>
                <h2>Verificar beneficiario</h2>
                <span>Ingresa el RUT del paciente</span>
              </div>
            </div>

            <div class="rut-validator-card-body">

              <!-- RUT -->
              <div class="form-group">
                <label for="rutPaciente">
                  RUT <span>*</span>
                </label>

                <input
                  id="rutPaciente"
                  type="text"
                  class="form-control rut-input"
                  autocomplete="off"
                  maxlength="12"
                  placeholder="Ej: 12.345.678-9"
                  [formControl]="rutPacienteFind"
                  [ngClass]="{ 'is-invalid': shouldShowRutError() }"
                  [disabled]="cargando"
                  (input)="onRutInput()"
                  (keydown)="onRutKeydown($event)">

                <div class="invalid-feedback" *ngIf="shouldShowRutError()">
                  <span *ngIf="rutPacienteFind.hasError('required')">
                    Este campo es obligatorio.
                  </span>

                  <span
                    *ngIf="
                      !rutPacienteFind.hasError('required') &&
                      rutPacienteFind.hasError('rutInvalido')
                    ">
                    El RUT ingresado no es válido.
                  </span>
                </div>
              </div>

              <!-- BOTÓN -->
              <button
                type="button"
                class="btn rut-validator-button"
                [disabled]="cargando"
                (click)="verificarPaciente()">

                <ng-container *ngIf="!cargando">
                  <i class="fi fi-rr-search"></i>
                  Verificar
                </ng-container>

                <ng-container *ngIf="cargando">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true">
                  </span>
                  Verificando...
                </ng-container>
              </button>

              <!-- LOADING -->
              <div class="rut-validation-loading" *ngIf="cargando">
                <div class="validation-progress">
                  <div class="validation-progress-bar"></div>
                </div>

                <span>
                  Estamos verificando la información del paciente...
                </span>
              </div>

              <!-- RESULTADO EXITOSO -->
              <div
                class="rut-validation-result rut-validation-success"
                *ngIf="estadoValidacion === 'success'">

                <div class="rut-result-icon">
                  <i class="fi fi-rr-check"></i>
                </div>

                <strong class="rut-result-title">
                  Sí, es paciente AlmaMedis
                </strong>

                <span class="rut-result-rut">
                  RUT {{ rutConsultado }}
                </span>

                <p class="rut-result-description">
                  Tiene un convenio activo en la plataforma de telemedicina.
                </p>
              </div>

              <!-- RESULTADO ERROR -->
              <div
                class="rut-validation-result rut-validation-error"
                *ngIf="estadoValidacion === 'error'">

                <div class="rut-result-icon">
                  <i class="fi fi-rr-cross-small"></i>
                </div>

                <strong class="rut-result-title">
                  No es paciente AlmaMedis
                </strong>

                <span class="rut-result-rut" *ngIf="rutConsultado">
                  RUT {{ rutConsultado }}
                </span>

                <p class="rut-result-description">
                  {{ mensajeValidacion }}
                </p>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </main>
</div>